<template>
    <BreadCrumb PageTitle="Ajouter une règle de contrôle" />
    <AddRule />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddRule from "@/components/Rules/AddRule.vue";

    export default defineComponent({
      name: "AddRulePage",
      components: {
        BreadCrumb,
        AddRule,
      },
    });
  </script>